/*!

=========================================================
* Purity UI Dashboard - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/purity-ui-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/purity-ui-dashboard/blob/master/LICENSE.md)

* Design by Creative Tim & Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
//import React from "react";
//import ReactDOM from "react-dom";
//import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

//import AuthLayout from "layouts/Auth.js";
//import AdminLayout from "layouts/Admin.js";
//import RTLLayout from "layouts/RTL.js";

//ReactDOM.render(
  //<HashRouter>
    //<Switch>
      //<Route path={`/auth`} component={AuthLayout} />
      //<Route path={`/admin`} component={AdminLayout} />
      //<Route path={`/rtl`} component={RTLLayout} />
      //<Redirect from={`/`} to="/admin/dashboard" />
    //</Switch>
  //</HashRouter>,
//);

import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import RTLLayout from "layouts/RTL.js";
import Login from "views/Login/index";
import Recover from "views/Recover/recover";
import InsertNewPassword from "views/Recover/insertNewPassword";
import InsertCode from "views/Recover/insertCode";
import { ChakraProvider } from "@chakra-ui/react/dist/chakra-ui-react.cjs";
import PrivateRoute from "components/PrivateRoute/PrivateRoute";

ReactDOM.render(
  <HashRouter>
    <ChakraProvider>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/auth" component={AuthLayout} />
        <PrivateRoute path="/admin" component={AdminLayout} />
        <Route path="/rtl" component={RTLLayout} />
        <Route path="/recover" component={Recover} />
        <Route path="/insertNewPassword" component={InsertNewPassword} />
        <Route path="/insertCode" component={InsertCode} />
        <Redirect from="/" to="/login" />

        
      </Switch>
    </ChakraProvider>
  </HashRouter>,
  document.getElementById("root")
);